const TUI_ITALIAN_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Numero', 'Numero carta'],
  cardExpiry: ['Scade il', 'Valida fino al']
};
const TUI_ITALIAN_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Tinta unita', 'Gradiente'],
  toolbarTools: {
    undo: 'Annulla',
    redo: 'Rifai',
    font: 'Font',
    fontStyle: 'Stile font',
    fontSize: 'Dimensione font',
    bold: 'Grassetto',
    italic: 'Corsivo',
    underline: 'Sottolineato',
    strikeThrough: 'Barrato',
    justify: 'Giustifica',
    justifyLeft: 'Allinea a sinistra',
    justifyCenter: 'Allinea al centro',
    justifyRight: 'Allinea a destra',
    justifyFull: 'Giustifica pieno',
    list: 'Lista',
    indent: 'Rientro',
    outdent: 'Elimina rientro',
    unorderedList: 'Lista non ordinata',
    orderedList: 'Lista ordinata',
    quote: 'Virgolette',
    foreColor: 'Colore',
    backColor: 'Colore sfondo',
    hiliteColor: 'Evidenziazione del testo',
    clear: 'Pulisci',
    link: 'Link',
    attach: 'Allega file',
    tex: 'Inserisci TeX',
    code: 'Codice',
    image: 'Inserisci image',
    insertHorizontalRule: 'Inserisci riga orizzontale',
    superscript: 'Apice',
    subscript: 'Pedice',
    insertTable: 'Inserisci tabella',
    insertGroup: 'Insert group',
    hiliteGroup: 'Hilite group',
    removeGroup: 'Remove group',
    insertAnchor: 'Insert anchor',
    mergeCells: 'Unisci celle',
    splitCells: 'Dividi celle',
    rowsColumnsManaging: 'Gestione righe e colonne',
    cellColor: 'Colore cella',
    setDetails: 'Details',
    removeDetails: 'Remove details'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'anchor'
  },
  editorTableCommands: [['Inserisci colonna prima', 'Inserisci colonna dopo'], ['Inserisci riga prima', 'Inserisci riga dopo'], ['Cancella colonna', 'Cancella riga']],
  editorCodeOptions: ['Codice nel testo', 'Codice nel blocco'],
  editorFontOptions: {
    small: 'Small',
    normal: 'Normale',
    large: 'Large',
    title: 'Titolo',
    subtitle: 'Sottotitolo'
  }
};
const TUI_ITALIAN_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Mostra/Nascondi',
  paginationTexts: {
    pages: 'Pagine',
    linesPerPage: 'Righe per pagina',
    of: 'di'
  }
};
const TUI_ITALIAN_LANGUAGE_COUNTRIES = {
  AD: 'Andorra',
  AE: 'Emirati Arabi Uniti',
  AF: 'Afghanistan',
  AG: 'Antigua and Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AR: 'Argentina',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AZ: 'Azerbaijan',
  BA: 'Bosnia Erzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgio',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Saint Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei Darussalam',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius e Saba',
  BR: 'Brasile',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BW: 'Botswana',
  BY: 'Bielorussia',
  BZ: 'Belize',
  CA: 'Canada',
  CD: 'Repubblica Democratica del Congo',
  CF: 'Repubblica Centroafricana',
  CG: 'Repubblica del Congo',
  CH: 'Svizzera',
  CI: "Costa d'Avorio",
  CL: 'Cile',
  CM: 'Camerun',
  CN: 'Cina',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Capo Verde',
  CW: 'Curaçao',
  CY: 'Cipro',
  CZ: 'Repubblica Ceca',
  DE: 'Germania',
  DJ: 'Gibuti',
  DK: 'Danimarca',
  DM: 'Dominica',
  DO: 'Repubblica Dominicana',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egitto',
  ER: 'Eritrea',
  ES: 'Spagna',
  ET: 'Etiopia',
  FI: 'Finlandia',
  FJ: 'Fiji',
  FK: 'Isole Falkland',
  FM: 'Stati Federali della Micronesia',
  FR: 'Francia',
  GA: 'Gabon',
  GB: 'Regno Unito',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'Guyana',
  GH: 'Ghana',
  GI: 'Gibilterra',
  GL: 'Groenlandia',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadalupa',
  GQ: 'Guinea Equatoriale',
  GR: 'Grecia',
  GT: 'Guatemala',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HR: 'Croazia',
  HT: 'Haiti',
  HU: 'Ungheria',
  ID: 'Indonesia',
  IE: 'Eire',
  IL: 'Israele',
  IN: 'India',
  IQ: 'Iraq',
  IR: 'Iran',
  IS: 'Islanda',
  IT: 'Italia',
  JM: 'Giamaica',
  JO: 'Giordania',
  JP: 'Giappone',
  KE: 'Kenya',
  KG: 'Kirghizistan',
  KH: 'Cambogia',
  KM: 'Comore',
  KN: 'Saint Kitts e Nevis',
  KP: 'Corea del Nord',
  KR: 'Corea del Sud',
  KW: 'Kuwait',
  KY: 'Isole Cayman',
  KZ: 'Kazakhistan',
  LA: 'Laos',
  LB: 'Libano',
  LC: 'Santa Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lituania',
  LU: 'Lussemburgo',
  LV: 'Lettonia',
  LY: 'Libia',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldavia',
  ME: 'Montenegro',
  MF: 'San Martino',
  MG: 'Madagascar',
  MK: 'Macedonia',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolia',
  MO: 'Macao',
  MQ: 'Martinica',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Maurizius',
  MV: 'Maldive',
  MW: 'Malawi',
  MX: 'Messico',
  MY: 'Malesia',
  MZ: 'Mozambico',
  NA: 'Namibia',
  NC: 'Nuova Caledonia',
  NE: 'Niger',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Paesi Bassi',
  NO: 'Norvegia',
  NP: 'Nepal',
  NZ: 'Nuova Zelanda',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Perù',
  PF: 'Polinesia Francese',
  PG: 'Papua Nuova Guinea',
  PH: 'Filippine',
  PK: 'Pakistan',
  PL: 'Polonia',
  PT: 'Portogallo',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Riunione',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Federazione Russa',
  RW: 'Ruanda',
  SA: 'Arabia Saudita',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Svezia',
  SG: 'Singapore',
  SH: "Sant'Elena",
  SI: 'Slovenia',
  SK: 'Slovacchia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'Sao Tome e Principe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Siria',
  SZ: 'Swaziland',
  TC: 'Isole Turks e Caicos',
  TD: 'Ciad',
  TG: 'Togo',
  TH: 'Tailandia',
  TJ: 'Tagikistan',
  TL: 'Timor Est',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Turchia',
  TT: 'Trinidad and Tobago',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ucraina',
  UG: 'Uganda',
  US: "Stati Uniti d'America",
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VC: 'Saint Vincent e Grenadine',
  VE: 'Venezuela',
  VG: 'Isole Vergini Britanniche',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemen',
  YT: 'Mayotta',
  ZA: 'Sud Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_ITALIAN_LANGUAGE_CORE = {
  months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
  close: 'Chiudi',
  clear: 'Campo libero',
  nothingFoundMessage: 'Non abbiamo trovato nulla',
  defaultErrorMessage: 'Il valore non è valido',
  spinTexts: ['Precedente', 'Prossimo'],
  shortWeekDays: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
  countries: TUI_ITALIAN_LANGUAGE_COUNTRIES
};
const TUI_ITALIAN_LANGUAGE_KIT = {
  cancel: 'Annulla',
  done: 'Fatto',
  more: 'Di più',
  otherDate: 'Altra data...',
  showAll: 'Show all',
  hide: 'Hide',
  mobileCalendarTexts: ['Scegli giorno', 'Scegli intervallo', 'Scegli i giorni'],
  range: ['da', 'a'],
  countTexts: ['Più', 'Meno'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'gg.mm.aaaa',
    MDY: 'mm.gg.aaaa',
    YMD: 'aaaa.mm.gg'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['Mostra password', 'Nascondi password'],
  copyTexts: ['Copia', 'Copiato'],
  shortCalendarMonths: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
  pagination: ['Pagina precedente', 'Pagina successiva'],
  fileTexts: {
    loadingError: 'Caricamento errore',
    preview: 'Anteprima',
    remove: 'Rimuovi'
  },
  inputFileTexts: {
    defaultLabelSingle: 'o trascinalo\u00A0qui',
    defaultLabelMultiple: 'o trascinali\u00A0qui',
    defaultLinkSingle: 'Scegliere il file',
    defaultLinkMultiple: 'Scegliere i file',
    maxSizeRejectionReason: 'Il file supera le dimensioni',
    formatRejectionReason: 'Formato file errato',
    drop: 'Trascina il file qui',
    dropMultiple: 'Trascina i file qui'
  },
  multiSelectTexts: {
    all: 'Seleziona tutto',
    none: 'Seleziona nessuno'
  },
  confirm: {
    yes: 'Sì',
    no: 'No'
  },
  previewTexts: {
    rotate: 'Ruota'
  },
  zoomTexts: {
    zoomOut: 'Rimpicciolisci',
    zoomIn: 'Ingrandisci',
    reset: 'Ripristina'
  },
  phoneSearch: 'Digitare il paese o il codice'
};
const TUI_ITALIAN_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_ITALIAN_LANGUAGE = {
  name: 'italian',
  ...TUI_ITALIAN_LANGUAGE_CORE,
  ...TUI_ITALIAN_LANGUAGE_KIT,
  ...TUI_ITALIAN_LANGUAGE_ADDON_TABLE,
  ...TUI_ITALIAN_LANGUAGE_ADDON_COMMERCE,
  ...TUI_ITALIAN_LANGUAGE_ADDON_EDITOR,
  ...TUI_ITALIAN_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_ITALIAN_LANGUAGE, TUI_ITALIAN_LANGUAGE_ADDON_COMMERCE, TUI_ITALIAN_LANGUAGE_ADDON_EDITOR, TUI_ITALIAN_LANGUAGE_ADDON_TABLE, TUI_ITALIAN_LANGUAGE_CORE, TUI_ITALIAN_LANGUAGE_COUNTRIES, TUI_ITALIAN_LANGUAGE_KIT, TUI_ITALIAN_LANGUAGE_LAYOUT };
